import * as FeatureHubReact from '@feature-hub/react';
import * as React from 'react';
import * as ReactDom from 'react-dom';
import * as UnifiedWebCommon from '@oneaudi/unified-web-common';
import * as oneGraphClient from '@oneaudi/onegraph-client';
import * as oneGraphQueryService from '@oneaudi/onegraph-query-service';
import * as oneGraphService from '@oneaudi/onegraph-service';
import * as styled from 'styled-components';
export const definedExternals = {
    '@feature-hub/react': FeatureHubReact,
    '@oneaudi/onegraph-client': oneGraphClient,
    '@oneaudi/onegraph-query-service': oneGraphQueryService,
    '@oneaudi/onegraph-service': oneGraphService,
    '@oneaudi/unified-web-common': UnifiedWebCommon,
    '@volkswagen-onehub/onegraph-client': oneGraphClient,
    react: React,
    'react-dom': ReactDom,
    'styled-components': styled,
};
export const providedExternals = {
    '@feature-hub/react': process.env.FEATURE_HUB_VERSION,
    '@oneaudi/onegraph-client': process.env.ONEGRAPH_CLIENT_VERSION,
    '@oneaudi/onegraph-query-service': process.env.SERVICE_ONEGRAPH_QUERY_SERVICE_VERSION,
    '@oneaudi/onegraph-service': process.env.SERVICE_ONEGRAPH_SERVICE_VERSION,
    '@oneaudi/unified-web-common': process.env
        .UNIFIED_WEB_COMMON_VERSION,
    '@volkswagen-onehub/onegraph-client': process.env
        .ONEGRAPH_CLIENT_VERSION,
    react: process.env.REACT_VERSION,
    'react-dom': process.env.REACT_DOM_VERSION,
    'styled-components': process.env.STYLED_COMPONENTS_VERSION,
};
//# sourceMappingURL=legacy.js.map